import FeaturedAwards from 'components/FilmPage/FeaturedAwards';
import { metadataLeft } from 'components/FilmPage/styled';
import styled from 'styled-components';

export default styled(FeaturedAwards)`
  position: relative;
  left: ${metadataLeft};
`;
